import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.array.includes";
import { testPattern } from "../utils/patterns.js";
var lazyRulesValues = [true, false, 'ondemand'];
export default {
  props: {
    value: {},
    error: {
      type: Boolean,
      default: null
    },
    errorMessage: String,
    noErrorIcon: Boolean,
    rules: Array,
    reactiveRules: Boolean,
    lazyRules: {
      type: [Boolean, String],
      validator: function validator(v) {
        return lazyRulesValues.includes(v);
      }
    }
  },
  data: function data() {
    return {
      isDirty: null,
      innerError: false,
      innerErrorMessage: void 0
    };
  },
  watch: {
    value: function value() {
      this.__validateIfNeeded();
    },
    reactiveRules: {
      handler: function handler(val) {
        var _this = this;

        if (val === true) {
          if (this.unwatchRules === void 0) {
            this.unwatchRules = this.$watch('rules', function () {
              _this.__validateIfNeeded(true);
            });
          }
        } else if (this.unwatchRules !== void 0) {
          this.unwatchRules();
          this.unwatchRules = void 0;
        }
      },
      immediate: true
    },
    focused: function focused(_focused) {
      if (this.lazyRules !== 'ondemand') {
        if (_focused === true) {
          if (this.isDirty === null) {
            this.isDirty = false;
          }
        } else if (this.isDirty === false && this.hasRules === true) {
          this.isDirty = true;
          this.validate();
        }
      }
    }
  },
  computed: {
    hasRules: function hasRules() {
      return this.rules !== void 0 && this.rules !== null && this.rules.length > 0;
    },
    hasError: function hasError() {
      return this.error === true || this.innerError === true;
    },
    computedErrorMessage: function computedErrorMessage() {
      return typeof this.errorMessage === 'string' && this.errorMessage.length > 0 ? this.errorMessage : this.innerErrorMessage;
    }
  },
  mounted: function mounted() {
    this.validateIndex = 0;
  },
  beforeDestroy: function beforeDestroy() {
    this.unwatchRules !== void 0 && this.unwatchRules();
  },
  methods: {
    resetValidation: function resetValidation() {
      this.validateIndex++;
      this.innerLoading = false;
      this.isDirty = null;
      this.innerError = false;
      this.innerErrorMessage = void 0;
    },

    /*
     * Return value
     *   - true (validation succeeded)
     *   - false (validation failed)
     *   - Promise (pending async validation)
     */
    validate: function validate() {
      var _this2 = this;

      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.value;

      if (this.hasRules !== true) {
        return true;
      }

      this.validateIndex++;

      if (this.innerLoading !== true && this.lazyRules !== true) {
        this.isDirty = true;
      }

      var update = function update(err, msg) {
        if (_this2.innerError !== err) {
          _this2.innerError = err;
        }

        var m = msg || void 0;

        if (_this2.innerErrorMessage !== m) {
          _this2.innerErrorMessage = m;
        }

        if (_this2.innerLoading !== false) {
          _this2.innerLoading = false;
        }
      };

      var promises = [];

      for (var i = 0; i < this.rules.length; i++) {
        var rule = this.rules[i];
        var res = void 0;

        if (typeof rule === 'function') {
          res = rule(val);
        } else if (typeof rule === 'string' && testPattern[rule] !== void 0) {
          res = testPattern[rule](val);
        }

        if (res === false || typeof res === 'string') {
          update(true, res);
          return false;
        } else if (res !== true && res !== void 0) {
          promises.push(res);
        }
      }

      if (promises.length === 0) {
        update(false);
        return true;
      }

      if (this.innerLoading !== true) {
        this.innerLoading = true;
      }

      var index = this.validateIndex;
      return Promise.all(promises).then(function (res) {
        if (index !== _this2.validateIndex) {
          return true;
        }

        if (res === void 0 || Array.isArray(res) === false || res.length === 0) {
          update(false);
          return true;
        }

        var msg = res.find(function (r) {
          return r === false || typeof r === 'string';
        });
        update(msg !== void 0, msg);
        return msg === void 0;
      }, function (e) {
        if (index === _this2.validateIndex) {
          console.error(e);
          update(true);
          return false;
        }

        return true;
      });
    },
    __validateIfNeeded: function __validateIfNeeded(changedRules) {
      if (this.hasRules === true && this.lazyRules !== 'ondemand' && (this.isDirty === true || this.lazyRules !== true && changedRules !== true)) {
        this.validate();
      }
    }
  }
};